import React, { useState, useEffect, useReducer, useRef } from "react";
import _ from "lodash";
import SelectBox from "devextreme-react/select-box";
import ScrollView from "devextreme-react/scroll-view";
import sa3Reducer from "../../reducers/sa3";
import DateBox from "devextreme-react/date-box";
import "../../styles/sps.css";
import SaveButton from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { alert } from "devextreme/ui/dialog";
import { Validator, RequiredRule } from "devextreme-react/validator";
import ValidationGroup from "devextreme-react/validation-group";
import { set } from "../../common/utils";
import { postUserLog } from "../../actions/common";
import { TextBox } from "devextreme-react";
import { custom } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import { LoadPanel } from "devextreme-react/load-panel";
import { Popup } from "devextreme-react/popup";
import {
  searchValueByOneProperty,
  isDuplicatesByOneProperty,
} from "../settings/utils";
import * as utils from "../../common/utils";
import executeApiRequest from "../../common/executeApiRequest";

import DataGrid, {
  Column,
  Editing,
  HeaderFilter,
  Scrolling,
  Paging,
  Pager,
  Button,
  SearchPanel,
  Toolbar,
  Item,
  GroupPanel,
  Grouping,
} from "devextreme-react/data-grid";

const initialStates = {
  approvers: [],
  peopleData: [],
  reasonCodes: [],
  peopleList: [],
  userDetails: [],
};

const SA3GeneralInfo = (props: any) => {
  const [state, dispatch] = useReducer(sa3Reducer, initialStates);
  let { approvers, peopleList, userDetails } = state;
  let {
    siteId,
    tierId,
    data,
    activeItem,
    setStrategicA3Id,
    setisOpen,
    a3ID,
    handleA3Save,
    siteLocalDate,
  } = props;
  const generalInfoInitialState = {
    startDate: siteLocalDate,
    dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    closeDate: "",
    areaToSolve: "",
    problemToSolve: "",
    processOwner: "",
    processOwnerName: "",
    coach: "",
    coachName: "",
    teamMembers: [],
    newTeamMember: [],
    completedOn: siteLocalDate,
    status: "",
  };
  const [distinctUsers, setDistinctUsers] = useState<any>([]);
  const [generalInfoData, setGeneralInfoData] = useState<any>({
    ...generalInfoInitialState,
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isGeneralInfoDisabled, setIsGeneralInfoDisabled] = useState(false);
  const [isCompletedDateVisible, setIsCompletedDateVisible] = useState(false);
  const [isLoadPanelVisible, setIsLoadPanelVisible] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false);
  const [userData, setUserData] = useState({});
  const [processOwnerID, setProcessOwnerID] = useState({});
  const [coachID, setCoachID] = useState({});
  const [a3Property, setA3Property] = useState({});
  const teamMemberRef = useRef<any>(null);

  set("printInfoG", { approvers, peopleList, distinctUsers });
  useEffect(() => {
    let siteInfo = `tierId=${tierId}&siteId=${siteId}`;
    //setGeneralInfoData({ ...generalInfoInitialState });

    if (a3ID) {
      AsyncCallHandler(NEXUS_CONST.FETCH_A3_DATA + a3ID, NEXUS_CONST.GET).then(
        (res) => {
          if (res) {
            // teamMemberRef?.current?.instance?.refresh(true);

            setIsGeneralInfoDisabled(true);
            if (res?.data?.status === "Complete") {
              setIsCompletedDateVisible(true);
            }
            setIsDisabled(res?.data?.status === "Complete");
            setGeneralInfoData({
              ...generalInfoData,
              startDate: new Date(res?.data?.startDate),
              dueDate: new Date(res?.data?.dueDate),
              closeDate: new Date(res?.data?.closeDate),
              areaToSolve: res?.data?.areaToSolve?.toString(),
              problemToSolve: res?.data?.problemToSolve,
              processOwner: res?.data?.processOwner?.toString(),
              coach: res?.data?.coach?.toString(),
              processOwnerName: res?.data?.processOwnerName?.toString(),
              coachName: res?.data?.coachName?.toString(),
              teamMembers: res?.data?.teamMembers,
              completedOn: new Date(res?.data?.closeDate),
              status: res?.data?.status,
            });
          }
        }
      );
    } else {
      setGeneralInfoData({
        ...generalInfoData,
        areaToSolve: data[activeItem].title,
      });
    }
  }, [a3ID]);

  const toggleLoadPanel = () => {
    setIsLoadPanelVisible(true);
  };

  const hidePopUp = () => {
    setIsLoadPanelVisible(false);
  };
  let userExistsDialog = custom({
    title: "Info",
    messageHtml: "<b>User already exists for this Tier</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });

  let noUserExistsDialog = custom({
    title: "Info",
    messageHtml: "<b>No Record Found</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });

  let invalidInputDialog = custom({
    title: "Info",
    messageHtml: "<b>Invalid Search Input</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });

  const saveGeneralInfo = () => {
    let _generalInfoData = { ...generalInfoData };
    let newteam: any[] = teamMemberRef?.current?.instance
      .getVisibleRows()
      .map((x: any) => {
        if (!x.removed)
          return {
            A3MemberID: x.data.memberId,
            A3MemberName: x.data.memberName,
            A3MemberEmail: x.data.email,
          };
      });

    _generalInfoData.teamMembers = newteam.filter((x: any) => {
      if (x !== undefined) return x;
    });
    if (_generalInfoData?.coach === _generalInfoData?.processOwner) {
      alert("Coach and Process Owner Cannot Be The Same", "Alert");
    } else if (_generalInfoData?.dueDate < _generalInfoData?.startDate) {
      alert("Due Date cannot be lesser than the Start Date", "Alert");
    } else if (_generalInfoData.teamMembers.length === 0) {
      alert("Please enter atleast one Team Member", "Alert");
    } else if (
      isDuplicatesByOneProperty(_generalInfoData.teamMembers, "A3MemberID")
        .length > 0
        ? 1
        : 0
    ) {
      alert("Team Member should not contains duplicate user.", "Alert");
      return;
    } else if (
      _generalInfoData?.processOwner.length == 0 ||
      _generalInfoData?.coach.length == 0 ||
      _generalInfoData?.problemToSolve.length == 0 ||
      _generalInfoData?.areaToSolve.length == 0
    ) {
      alert("Please enter value in all values marked mandatory", "Alert");
    } else {
      let formData = {
        a3ID: a3ID === null ? null : a3ID,
        tierId: parseInt(tierId),
        processOwner: _generalInfoData?.processOwner,
        coach: _generalInfoData?.coach,
        processOwnerName: _generalInfoData?.processOwnerName,
        coachName: _generalInfoData?.coachName,
        startDate: _generalInfoData?.startDate,
        dueDate: _generalInfoData?.dueDate,
        areaToSolve: _generalInfoData?.areaToSolve,
        problemToSolve: _generalInfoData?.problemToSolve,
        teamMembers: _generalInfoData?.teamMembers,
        lastSaved: "0",
        section: props.activeTab,
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_A3_GENERAL_INFO_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (+res.data) {
          notify("General Info got saved successfully!", "success", 500);
          teamMemberRef?.current?.instance?.saveEditData();
          setStrategicA3Id(res.data);
          handleA3Save();
          // postUserLog({
          //   event: "General Info - Name Create",
          //   data: {
          //     action: `A3-${res.data} created`,
          //     module: "Digital Tier",
          //     section: "A3",
          //     siteUId: siteId,
          //     widget: "Strategic A3",
          //     tierId: tierId,
          //   },
          // });
        } else {
          notify(
            `General Info didn't get saved! 
          ${res.data}`,
            "error",
            500
          );
          setStrategicA3Id(a3ID);
        }
      });
    }
    setTimeout(setisOpen("G"), 1000);
  };

  const handleInputChange = (e: any) => {
    let name = e.component.option("name");
    let value = e.value;

    if (e.event) {
      // if (name === "coach" && value !== "") {
      //   setGeneralInfoData({
      //     ...generalInfoData,
      //     coach: e.value,
      //   });
      // } else if (name === "newTeamMember" && !value.includes(";")) {
      //   setGeneralInfoData({
      //     ...generalInfoData,
      //     newTeamMember: e.value,
      //   });
      // } else
      if (name === "startDate" && value !== "") {
        setGeneralInfoData({
          ...generalInfoData,
          startDate: e.value,
        });
      } else {
        setGeneralInfoData({ ...generalInfoData, [name]: value });
      }
    } else if (name === "newTeamMember") {
      setGeneralInfoData({
        ...generalInfoData,
        newTeamMember: e.value,
      });
    }
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const onValueChanged = (eVal: any, a3Property: any, id: any) => {
    if (!isGeneralInfoDisabled || a3Property === "memberId") {
      let searchText = eVal.trim().toLowerCase();
      if (searchText !== "") {
        userDetails = [];
        setA3Property(a3Property);
        if (
          a3Property === "pOwner" ||
          a3Property === "Owner" ||
          a3Property === "memberId"
        ) {
          toggleLoadPanel();
          // const url =
          //   "Settings/getUsersBySearch?key=" +
          //   searchValueByOneProperty(searchText) +
          //   "&value=";
          // let URL = url + searchText;
          // let method = "get";
          // AsyncCallHandler(URL, method).then((res: any) => {
          //   if (res.data.length) {
          //     hidePopUp();
          //     if (res.data.length > 1) {
          //       populateUsers(res.data, a3Property);
          //     } else {
          //       populateSelectedData(res.data[0], a3Property);
          //     }
          //     return;
          //   } else {
          //     hidePopUp();
          //     noUserExistsDialog.show().then();
          //     return;
          //   }
          // });

          let URL = `${window.ENV.SPA_AUTHORITY}${
            NEXUS_CONST.SEARCH_USER_IDENTITY
          }?query=${searchText}&projectId=${utils.get("tenantId")}&type=USER`;

          executeApiRequest({
            url: URL,
            method: "get",
            accessToken: utils.get("accessToken"),
          })
            .then((res) => {
              if (res.data && res.data.results) {
                hidePopUp();
                if (res.data.results.length > 1) {
                  populateUsers(res.data.results, a3Property);
                } else {
                  populateSelectedData(res.data.results[0], a3Property);
                }
              } else {
                hidePopUp();
                noUserExistsDialog.show().then();
              }
            })
            .catch((err) => {
              console.error(err);
              hidePopUp();
            });
        }
      } else {
        invalidInputDialog.show().then((dialogResult: any) => {
          //peopleDataGrid.current.instance.refresh(true);
        });
      }
    }
  };

  const populateSelectedData = (data: any, a3Property: any) => {
    const fullName = `${data.familyName}, ${data.givenName}`;
    switch (a3Property) {
      case "pOwner": {
        setProcessOwnerID(data.username);
        return setGeneralInfoData({
          ...generalInfoData,
          processOwnerName: fullName,
          processOwner: data.username,
        });
      }
      case "Owner": {
        setCoachID(data.username);
        return setGeneralInfoData({
          ...generalInfoData,
          coachName: fullName,
          coach: data.username,
        });
      }
      case "memberId": {
        teamMemberRef?.current?.instance?.cellValue(
          0,
          "memberId",
          data.username
        );
        teamMemberRef?.current?.instance?.cellValue(0, "memberName", fullName);
        teamMemberRef?.current?.instance?.cellValue(0, "email", data.mail);
        return teamMemberRef?.current?.instance?.refresh(true);
      }
    }
  };

  const populateUsers = (data: any, a3Property: any) => {
    setUserData(data);
    togglePopup();
  };

  const cloneRowData = (e: any) => {
    togglePopup();
    populateSelectedData(e.row.data, a3Property);
  };

  const oneditorPrepared = (e: any) => {
    if (e.dataField === "memberId" && e.parentType === "dataRow") {
      e.editorOptions.onValueChanged = (e: any) => {
        if (e.event !== undefined) onValueChanged(e.value, "memberId", null);
      };
    }
  };

  const productLabel = { "aria-label": "Simple Product" };
  return (
    <>
      <div className="title-section ">
        {" "}
        <h2 className="sps_title">General Information</h2>{" "}
        <div className="sps-save-btn save-btn">
          <SaveButton
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveGeneralInfo}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="434px" className="sps-box-s">
        <ValidationGroup>
          <div className="dx-field-labelatc">
            <TextBox
              id="processOwnerName"
              name="processOwnerName"
              labelMode={"floating"}
              label="Process Owner*"
              onValueChanged={(e) => {
                !isGeneralInfoDisabled &&
                  e.event !== undefined &&
                  onValueChanged(e.value, "pOwner", "employeeID");
              }}
              value={generalInfoData?.processOwnerName}
              disabled={isGeneralInfoDisabled}
              validationMessagePosition="left"
              width={400}
            >
              <Validator>
                <RequiredRule message="Process Owner is required" />
              </Validator>
            </TextBox>{" "}
            <TextBox
              id="coachName"
              name="coachName"
              labelMode={"floating"}
              label="Coach*"
              value={generalInfoData?.coachName}
              disabled={isGeneralInfoDisabled}
              onValueChanged={(e) => {
                !isGeneralInfoDisabled &&
                  e.event !== undefined &&
                  onValueChanged(e.value, "Owner", "employeeID");
              }}
              width={400}
            >
              <Validator>
                <RequiredRule message="Coach is required" />
              </Validator>
            </TextBox>{" "}
          </div>
          <div className="dx-field-labelatc">
            <DateBox
              name="startDate"
              label="Start Date*"
              labelMode="floating"
              value={generalInfoData?.startDate}
              onValueChanged={handleInputChange}
              disabled={isGeneralInfoDisabled}
              type="date"
              useMaskBehavior={true}
              width={400}
              displayFormat="shortdate"
            ></DateBox>
            <DateBox
              name="dueDate"
              label="Due Date*"
              labelMode="floating"
              disabled={isGeneralInfoDisabled}
              value={generalInfoData?.dueDate}
              onValueChanged={handleInputChange}
              type="date"
              useMaskBehavior={true}
              width={400}
              displayFormat="shortdate"
            ></DateBox>
          </div>
          <div className="dx-field-labelatc">
            <SelectBox
              id="areaToSolve"
              name="areaToSolve"
              labelMode={"floating"}
              items={data}
              label="Area To Solve*"
              disabled={isGeneralInfoDisabled}
              value={generalInfoData?.areaToSolve}
              valueExpr="title"
              displayExpr="title"
              onValueChanged={handleInputChange}
              width={400}
              searchEnabled={true}
              inputAttr={productLabel}
              searchMode="contains"
              searchExpr="areaToSolve"
              searchTimeout={200}
              minSearchLength={0}
              showDataBeforeSearch={false}
            />
            <TextBox
              id="problemToSolve"
              name="problemToSolve"
              label="Problem To Solve*"
              labelMode="floating"
              disabled={isGeneralInfoDisabled}
              value={generalInfoData?.problemToSolve}
              width={400}
              onValueChanged={handleInputChange}
            />
          </div>
          <div className="dx-field-tagBox">
            <DateBox
              name="closeDate"
              label="Completed Date"
              labelMode="floating"
              value={generalInfoData?.closeDate}
              onValueChanged={handleInputChange}
              visible={isCompletedDateVisible}
              disabled={true}
              type="date"
              useMaskBehavior={true}
              // displayFormat="YYYY-MM-DD"
              displayFormat="shortdate"
              // width={400}
            ></DateBox>
          </div>
          <div className="dx-field-tagBox">
            {generalInfoData?.teamMembers && (
              <DataGrid
                ref={teamMemberRef}
                dataSource={generalInfoData?.teamMembers}
                keyExpr="a3id"
                showBorders={true}
                allowColumnReordering={true}
                onEditorPreparing={oneditorPrepared}
              >
                <SearchPanel visible={true} />
                <Editing
                  mode="batch"
                  allowDeleting={true}
                  allowAdding={true}
                  useIcons={true}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={500} />
                <Pager
                  visible={true}
                  allowedPageSizes={[500, 1000, 2000, 5000]}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <Toolbar>
                  <Item location="before">
                    <div className="informer">
                      <span className="name">Team Members</span>
                    </div>
                  </Item>
                  <Item location="after" visible={true} name="addRowButton" />
                  <Item location="after" visible={true} name="revertButton" />
                  <Item name="searchPanel" visible={true} />
                </Toolbar>
                <Column dataField="memberId" />
                <Column dataField="memberName" allowEditing={false} />
                <Column dataField="email" allowEditing={false} visible={false} />
              </DataGrid>
            )}
          </div>
        </ValidationGroup>
      </ScrollView>
      {isLoadPanelVisible && (
        <LoadPanel
          visible={isLoadPanelVisible}
          onHiding={hidePopUp}
          showPane={true}
        />
      )}
      <Popup
        visible={showPopup}
        hideOnOutsideClick={true}
        showCloseButton={true}
        onHiding={togglePopup}
        showTitle={true}
        title="Information"
        width="50%"
        height="400px"
      >
        <DataGrid dataSource={userData} height="300px" showBorders={true}>
          <Scrolling mode="virtual" />
          <Column dataField="employeeId" caption="HID" />
          <Column dataField="name" caption="Name" />
          <Column dataField="mail" caption="Mail" />
          <Column type="buttons" width={110} caption="action">
            <Button text="Select" onClick={cloneRowData} />
          </Column>
        </DataGrid>
      </Popup>
    </>
  );
};
export default SA3GeneralInfo;
